import { notification } from 'antd'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as programProviders from 'services/program'
import actions from './actions'

export function* SHOW_PROGRAM({ payload }) {
  yield put({
    type: 'program/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(programProviders.showProgram, payload.businessCode)
  if (response && response.loyalty_program) {
    const {
      _id: id,
      type,
      spend,
      visit,
      sign_up_bonus: signUpBonus = {},
      terms_and_conditions: terms = '',
    } = response.loyalty_program
    const {
      bonus_type: bonusType = '',
      bonus_value: bonusValue = 0,
      reward_name: rewardName = '',
      expire_in: expires = '',
    } = signUpBonus
    let item = {}
    if (type === 'spend') {
      const { dollar_value_spent: dollarVal, earned_points: points, levels: tiers } = spend
      item = {
        spend: {
          dollar_value_spent: dollarVal,
          earned_points: points,
          levels: tiers,
        },
      }
    } else {
      const { no_of_visit: visits, earned_points: vPoints, levels: vTiers } = visit
      item = {
        visit: {
          no_of_visit: visits,
          earned_points: vPoints,
          levels: vTiers,
        },
      }
    }
    item.sign_up_bonus = {
      bonus_type: bonusType,
      bonus_value: bonusValue,
      reward_name: rewardName,
      expire_in: expires,
    }
    yield put({
      type: 'program/SET_STATE',
      payload: {
        id,
        type,
        terms_and_conditions: terms,
        ...item,
      },
    })
  }
  yield put({
    type: 'program/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* UPDATE_PROGRAM({ payload }) {
  const { businessCode } = payload

  yield put({
    type: 'program/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(programProviders.updateProgram, payload)
  if (response) {
    yield put({
      type: 'program/SHOW_PROGRAM',
      payload: {
        businessCode,
      },
    })
    notification.success({
      message: 'Reward Program',
      description: response.data.message,
    })
  }
  yield put({
    type: 'program/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SHOW_PROGRAM, SHOW_PROGRAM),
    takeEvery(actions.UPDATE_PROGRAM, UPDATE_PROGRAM),
  ])
}
